import { Navigate, useLocation } from "react-router-dom";
import { NAVIGATION } from "Route/ConstantRoute";

function ProtectedRoutes({ children }) {
  const isLogin = localStorage.getItem("isLogin");
  const location = useLocation();
  const path = location.pathname;
  if (isLogin === "true" && path == "/") {
    return window.location.href = NAVIGATION.intent
    // return <Navigate to={NAVIGATION.intent} />;
  } else if (!isLogin || isLogin === "false") {
    return <Navigate to={NAVIGATION.auth.login} />;
  }
  return children;
}

export default ProtectedRoutes;
